// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as ImageSize$Showside from "../utils/ImageSize.bs.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
import * as PullDownModal$Showside from "./PullDownModal.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as CustomActionButton$Showside from "./CustomActionButton.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function toSubset(t) {
  var disable = Belt_Option.isNone(t.image) && Belt_Option.isNone(t.smallImage) && Belt_Option.isNone(t.link);
  return {
    disable: disable,
    image: t.image,
    smallImage: t.smallImage,
    link: t.link,
    customScript: t.customScript,
    customAction: t.customAction
  };
}
function SizeGuideModal$Modal(Props) {
  var isOpen = Props.isOpen;
  var data = Props.data;
  var label = Props.label;
  var onClose = Props.onClose;
  var match = ViewportContext$Showside.use(undefined);
  var viewportWidth = match.windowSize.width;
  var breakpoint = match.breakpoint;
  var match$1 = data.image;
  var match$2 = data.smallImage;
  var src = match$1 !== undefined ? match$2 !== undefined && breakpoint < 2 ? match$2 : match$1 : match$2 !== undefined ? match$2 : undefined;
  var match$3 = ImageSize$Showside.useImageSize(Belt_Option.getWithDefault(src, ""));
  var maxWidth = Caml.int_min(match$3[0], 1366);
  var tmp = {
    children: src !== undefined ? React.createElement(SmartImg$Showside.Sized.make, {
      src: src,
      containerWidth: breakpoint >= 2 && maxWidth < viewportWidth ? maxWidth : viewportWidth,
      fit: /* ScaleDown */0,
      priority: 0,
      alt: label
    }) : null,
    isOpen: isOpen,
    onClose: onClose,
    label: label
  };
  if (data.link !== undefined) {
    tmp.learnMoreLink = Caml_option.valFromOption(data.link);
  }
  return React.createElement(PullDownModal$Showside.make, tmp);
}
SizeGuideModal$Modal.displayName = "SizeGuideModal.Modal";
var Modal = {
  make: SizeGuideModal$Modal
};
function getClosestSubset(sizeGuide, categories, activeCategoryId) {
  var match = sizeGuide.overrides;
  var override;
  if (activeCategoryId !== undefined && match !== undefined) {
    var overrides = Caml_option.valFromOption(match);
    var path = Category$Showside.getCategoryPathById(categories, activeCategoryId);
    var reversedPath = Belt_Array.reverse(path);
    override = Belt_Array.get(Belt_Array.keepMap(Belt_Array.map(reversedPath, function (item) {
      return Js_dict.get(overrides, item.id);
    }), function (a) {
      return a;
    }), 0);
  } else {
    override = undefined;
  }
  return Belt_Option.getWithDefault(override, toSubset(sizeGuide));
}
function SizeGuideModal(Props) {
  var sizeGuide = Props.sizeGuide;
  var activeCategoryId = Props.activeCategoryId;
  var product = Props.product;
  var variant = Props.variant;
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var transitiveAccount = match$1.transitiveAccount;
  var categories = match$1.categories;
  var subset = React.useMemo(function () {
    return getClosestSubset(sizeGuide, categories, activeCategoryId);
  }, [activeCategoryId, match$1.lastModifiedAt]);
  var match$2 = React.useState(function () {
    return false;
  });
  var setModalOpen = match$2[1];
  var modalOpen = match$2[0];
  var handleCustomScriptClick = function (code, e) {
    Belt_Option.forEach(code, function (code) {
      CustomScript$Showside.triggerCustomFunction(code, product, variant, undefined, "size guide", undefined, undefined);
    });
  };
  var customScript = Belt_Option.keep(subset.customScript, function (code) {
    return code !== "";
  });
  var customAction = Belt_Option.flatMap(subset.customAction, function (customActionId) {
    return Belt_Option.flatMap(transitiveAccount, function (account) {
      return Belt_Array.getBy(account.customActions, function (a) {
        return Caml_obj.equal(a.id, customActionId);
      });
    });
  });
  var renderButton = function (subset) {
    var className = CSS$Showside.prefix("text-secondary text-lg font-normal underline cursor-pointer whitespace-nowrap");
    var match = subset.link;
    var match$1 = subset.image;
    var match$2 = subset.smallImage;
    var exit = 0;
    if (customAction !== undefined) {
      var partial_arg = customAction.onClickFn;
      return React.createElement(React.Fragment, undefined, React.createElement(CustomActionButton$Showside.make, {
        product: product,
        variant: variant,
        customAction: customAction,
        renderDefault: React.createElement(Link$Showside.make, {
          children: sizeGuide.label,
          unstyled: true,
          className: className
        }),
        onClick: function (param) {
          return handleCustomScriptClick(partial_arg, param);
        }
      }));
    }
    if (customScript !== undefined) {
      var partial_arg$1 = customScript;
      return React.createElement(Link$Showside.make, {
        children: sizeGuide.label,
        unstyled: true,
        className: className,
        onClick: function (param) {
          return handleCustomScriptClick(partial_arg$1, param);
        }
      });
    }
    if (match !== undefined && match$1 === undefined) {
      if (match$2 === undefined) {
        return React.createElement(Link$Showside.make, {
          children: sizeGuide.label,
          href: match,
          unstyled: true,
          className: className,
          openLinkInNewTab: true
        });
      }
      if (match$2 === undefined) {
        return null;
      }
    } else {
      exit = 2;
    }
    if (exit === 2 && match$1 === undefined && match$2 === undefined) {
      return null;
    }
    return React.createElement(Link$Showside.make, {
      children: sizeGuide.label,
      unstyled: true,
      className: className,
      onClick: function (param) {
        Curry._1(setModalOpen, function (param) {
          return true;
        });
      }
    });
  };
  var renderModal = function (subset) {
    return React.createElement(SizeGuideModal$Modal, {
      isOpen: modalOpen,
      data: subset,
      label: sizeGuide.label,
      onClose: function (param) {
        Curry._1(setModalOpen, function (param) {
          return false;
        });
      }
    });
  };
  return React.createElement(React.Fragment, undefined, renderButton(subset), renderModal(subset));
}
SizeGuideModal.displayName = "SizeGuideModal";
var make = SizeGuideModal;
export { toSubset, Modal, getClosestSubset, make };
/* react Not a pure module */